module.exports = __webpack_public_path__ + "static/media/network.4493f741.png";